import React, { useContext } from 'react';
import * as R from 'ramda';
import Stack from '@mui/material/Stack';
import { ActionBar } from 'common';
import CustomerInformationAccordion from '../../components/CustomerInformationAccordion';
import Terminals from './Terminals';
import Products from './Products';
import { CreateCustomerAuthContext } from '../Create';
import { invalidProduct } from './validationUtils';
import TitleBar from '../TitleBarConnector';

const stackSTyles = {
  /* eslint-disable sort-keys-fix/sort-keys-fix */
  mx: 'auto',
  pt: { xs: 6, lg: 9 },
  pb: 10,
  width: { xs: 1, lg: 760 },
};

const TerminalsProducts = () => {
  const { info } = useContext(CreateCustomerAuthContext);
  const { authorizationType, controlType, products, terminals } = info;

  const isSelectedTerminalAuthorized = R.allPass([
    R.always(controlType === 'SINGLE'),
    R.length,
    R.o(R.prop('customerAuthorizationId'), R.head),
  ])(terminals);

  const invalidProducts = R.and(
    R.equals(authorizationType, 'SPECIFIC'),
    R.equals(products.length, 0)
  );

  const continueDisabled = R.compose(
    R.or(invalidProducts),
    R.or(R.any(invalidProduct, products)),
    R.or(isSelectedTerminalAuthorized),
    R.or(R.not(terminals.length)),
    R.or(R.not(R.all(R.both(R.has('authorizationType'), R.complement(R.isNil)), products ?? [])))
  )(false);

  return (
    <>
      <TitleBar />

      <Stack spacing={2} sx={stackSTyles}>
        <CustomerInformationAccordion customerAuthorization={{ ...info }} />
        <Terminals isSelectedTerminalAuthorized={isSelectedTerminalAuthorized} />
        <Products isSelectedTerminalAuthorized={isSelectedTerminalAuthorized} />
      </Stack>

      <ActionBar
        backLink="../customer-information"
        continueLink="../loading-control-numbers"
        disableAction={continueDisabled}
      />
    </>
  );
};

export default TerminalsProducts;
